<template>
	<div v-if="status === 'check'" class="ticket_container">
		<div>
			<h3 class="mb_10">{{ $t('cs.ticket.text3') }}</h3>
			<p class="mb_20 fs_14 fc_gray_1">
				{{ $t('cs.ticket.text4') }} {{ $t('cs.ticket.text5') }}
			</p>
			<input
				type="text"
				class="mb_10"
				:placeholder="$t('cs.ticket.input1')"
				v-model="ticketId"
			/>
			<input
				type="password"
				class="mb_50"
				:placeholder="$t('cs.ticket.input2')"
				v-model="password"
			/>
			<button class="button_bg_red" @click="createTicketToken">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</div>
	<div v-if="status === 'showDetail'" class="q_write complete">
		<div class="select_wrap mb_10">
			<select class="contact_type" v-model="typeSeq" disabled>
				<option value="">
					{{ $t('cs.placeholder.type') }}
				</option>
				<option
					v-for="item in ticketTypeList"
					:key="item.seq"
					:value="item.seq"
				>
					{{ item.title }}
				</option>
			</select>
		</div>

		<input type="text" class="mb_10" :value="ticketInfo?.title" readonly />

		<div class="ask">
			<div class="ask_content">{{ ticketInfo?.content }}</div>
			<div v-if="ticketInfo?.reply" class="ask_answer d_flex">
				<span>A</span>
				<p>
					{{ ticketInfo?.reply }}
				</p>
			</div>
		</div>
		<div class="inquiry_button_area">
			<button class="button_bg_red" @click="initData">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</div>
</template>

<script>
import { createTicketToken, fetchTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'InquiryDetail',
	data() {
		return {
			status: 'check',
			typeSeq: '',
			ticketTypeList: [],
			ticketId: '',
			password: '',
			ticketSeq: 0,
			token: '',
			ticketInfo: {},
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadTicketTypeList();
		},
		initData() {
			this.status = 'check';
			this.typeSeq = '';
			this.ticketId = '';
			this.password = '';
			this.token = '';
			this.ticketInfo = {};
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticketTypeList = data.filter(item => {
				return item.allow_guest === 'Y';
			});
		},
		async createTicketToken() {
			const params = {
				ticket_id: this.ticketId,
				password: this.password,
			};
			await createTicketToken(params)
				.then(({ token }) => {
					this.token = token;
					this.loadTicket();
				})
				.catch(commonError);
		},
		async loadTicket() {
			await fetchTicket(this.ticketSeq, this.token)
				.then(({ ticket_info }) => {
					this.ticketInfo = ticket_info;
					this.typeSeq = ticket_info.type_seq;
					this.status = 'showDetail';
				})
				.catch(commonError);
		},
	},
};
</script>

<style scoped>
.ticket_container {
	width: 440px;
	min-height: 395px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: 0 auto;
}
.mb_50 {
	margin-bottom: 50px;
}
.rtr_cs .fc_gray_1 {
	color: #919191;
}
.q_write.complete input {
	font-size: 16px;
	color: #333;
}
.q_write.complete .select_wrap select {
	background: url('~@/assets/images/icon/arrow_down.png') #f0f0f0 no-repeat 99%
		50%/12px auto;
	color: #333;
}
.q_write.complete .ask {
	background-color: #f0f0f0;
	color: #333;
}
.q_write.complete .ask_content {
	padding-bottom: 20px;
	border-bottom: 1px solid #ddd;
}
.q_write.complete .ask_answer {
	padding-top: 25px;
	line-height: 25px;
}
.q_write.complete .ask_answer span {
	margin-right: 10px;
	display: inline-block;
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #50be3d;
	color: #fff;
	text-align: center;
	line-height: 25px;
	font-size: 14px;
}
</style>
